import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box, extendTheme } from '@chakra-ui/react';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Rewards from './pages/Rewards';
import HowItWorks from './pages/HowItWorks';
import Whitepaper from './pages/Whitepaper';

// Create a custom theme
const theme = extendTheme({
  styles: {
    global: {
      body: {
        bg: 'gray.900',
        color: 'white',
      },
    },
  },
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
});

function App() {
  return (
    <Router>
      <Box minH="100vh" bg="gray.900">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/rewards" element={<Rewards />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/whitepaper" element={<Whitepaper />} />
        </Routes>
      </Box>
    </Router>
  );
}

export default App;
